import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { VendorsComponent } from './vendors.component';
import { VendorEditComponent } from './edit/vendor-edit/vendor-edit.component';
import { VendorCreateComponent } from './vendor-create/vendor-create.component';
import { VendorPaymentEntryComponent } from './vendor-payment-entry/vendor-payment-entry.component';
import { VendorViewComponent } from './vendor-view/vendor-view.component';
import { VendorEditaccountComponent } from './edit/vendor-editaccount/vendor-editaccount.component';
import { VendorNotesComponent } from './edit/vendor-notes/vendor-notes.component';
import { VendorContactsComponent } from './edit/vendor-contacts/vendor-contacts.component';
import { VendorSettingsComponent } from './edit/vendor-settings/vendor-settings.component';
import { VendorAddonComponent } from './edit/vendor-addon/vendor-addon.component';
import { VendorTransactionsComponent } from './vendor-transactions/vendor-transactions.component';
import { VendorItemlookupComponent } from './vendor-itemlookup/vendor-itemlookup.component';
import { VendorInvoiceComponent } from './vendor-invoice/vendor-invoice.component';
import { VendorInvoiceCompleteComponent } from './vendor-invoice/vendor-invoice-complete/vendor-invoice-complete.component';
import { NoPoItemsModalComponent } from './vendor-invoice/no-po-items-modal/no-po-items-modal.component';
import { VendorsDashboardComponent } from './vendors-dashboard/vendors-dashboard.component';
import { VendorCreditComponent } from './vendor-credit/vendor-credit.component';
import { VendorPhonePipePipe } from './vendor-phone-pipe.pipe';

import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { VendorAllocationsComponent } from './vendor-allocations/vendor-allocations.component';
import { VendordashPaymentsComponent } from './vendors-dashboard/vendordash-payments/vendordash-payments.component';
import { VendordashInvoiceComponent } from './vendors-dashboard/vendordash-invoice/vendordash-invoice.component';
import { CustomersModule } from '../customers/customers.module';
import { VendordashOverdueComponent } from './vendors-dashboard/vendordash-overdue/vendordash-overdue.component';
import { AllVendorsComponent } from './vendors-dashboard/all-vendors/all-vendors.component';
import { VendordashOutstandingGrnsComponent } from './vendors-dashboard/vendordash-outstanding-grns/vendordash-outstanding-grns.component';
import { VendordashPartialReceiptsComponent } from './vendors-dashboard/vendordash-partial-receipts/vendordash-partial-receipts.component';
import { VendordashInvoiceIssuesComponent } from './vendors-dashboard/vendordash-invoice-issues/vendordash-invoice-issues.component';
import { VendordashOpenPosComponent } from './vendors-dashboard/vendordash-open-pos/vendordash-open-pos.component';
import { VendordashReadyToPayComponent } from './vendors-dashboard/vendordash-ready-to-pay/vendordash-ready-to-pay.component';
import { VendordashTop100Component } from './vendors-dashboard/vendordash-top-100/vendordash-top-100.component';
import { SharedModule } from '../shared/shared.module';
import { VrptComponent } from './vrpt/vrpt.component';
import { VendorReportsComponent } from './vendor-reports/vendor-reports.component'
import { ClipboardModule } from '@angular/cdk/clipboard';
import { VrptContentComponent } from './vrpt/vrpt-content/vrpt-content.component';
import { CheckPrintingComponent } from './check-printing/check-printing.component';
import { PendingPaymentRunsComponent } from './pending-payment-runs/pending-payment-runs.component';
import { PaymentRunReviewComponent } from './payment-run-review/payment-run-review.component';
import { PaymentRunReportComponent } from './payment-run-report/payment-run-report.component';
import { VendorDailyTransactionsComponent } from './vendor-daily-transactions/vendor-daily-transactions.component';
import { VendorPaymentReportComponent } from './vendor-payment-report/vendor-payment-report.component';
import { NoRgaItemsModalComponent } from './vendor-credit/no-rga-items-modal/no-rga-items-modal.component';
import { VendorPoUploadComponent } from './vendor-po-upload/vendor-po-upload.component';
import { VendorInvoiceUploadComponent } from './vendor-invoice-upload/vendor-invoice-upload.component';
import { VendorCreditUploadComponent } from './vendor-credit-upload/vendor-credit-upload.component';

const maskConfigFunction: () => Partial<IConfig> = () => {
	return {
		validation: false,
	};
};

@NgModule({
	declarations: [
		VendorsComponent,
		VendorEditComponent,
		VendorCreateComponent,
		VendorPaymentEntryComponent,
		VendorViewComponent,
		VendorEditaccountComponent,
		VendorNotesComponent,
		VendorContactsComponent,
		VendorSettingsComponent,
		VendorAddonComponent,
		VendorTransactionsComponent,
		VendorItemlookupComponent,
		VendorInvoiceComponent,
		VendorInvoiceCompleteComponent,
		NoPoItemsModalComponent,
		VendorsDashboardComponent,
		VendorCreditComponent,
		VendorPhonePipePipe,
		VendorAllocationsComponent,
		VendordashPaymentsComponent,
		VendordashInvoiceComponent,
		VendordashOverdueComponent,
		AllVendorsComponent,
		VendordashOutstandingGrnsComponent,
		VendordashPartialReceiptsComponent,
		VendordashInvoiceIssuesComponent,
		VendordashOpenPosComponent,
		VendordashReadyToPayComponent,
		VendordashTop100Component,
		VrptComponent,
		VendorReportsComponent,
		VrptContentComponent,
		CheckPrintingComponent,
		PendingPaymentRunsComponent,
		PaymentRunReviewComponent,
		PaymentRunReportComponent,
		VendorDailyTransactionsComponent,
		VendorPaymentReportComponent,
  NoRgaItemsModalComponent,
		VendorPoUploadComponent,
		VendorInvoiceUploadComponent,
		VendorCreditUploadComponent,
	],
	imports: [
		CommonModule,
		BrowserModule,
		RouterModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,
		NgxExtendedPdfViewerModule,
		FormsModule,
		NgxDropzoneModule,
		MatToolbarModule,
		MatButtonModule,
		MatDialogModule,
		MatDividerModule,
		MatInputModule,
		MatTableModule,
		MatCheckboxModule,
		MatSortModule,
		MatPaginatorModule,
		MatFormFieldModule,
		MatAutocompleteModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatExpansionModule,
		MatSelectModule,
		MatMenuModule,
		MatIconModule,
		MatSlideToggleModule,
		MatStepperModule,
		MatChipsModule,
		MatListModule,
		MatTabsModule,
		SharedModule,
		MatButtonToggleModule,
		MatTooltipModule,
		MatProgressSpinnerModule,
		MatGridListModule,
		ClipboardModule,
		CustomersModule,
		NgxMaskModule.forRoot(maskConfigFunction),
	],
	providers: [
		GlobalSearchService
	],
})
export class VendorsModule {}
